import _ from "lodash"

const MAX_SIBLINGS = 5

/**
 * Determines if a node is extendable given the following conditions:
 *  - It is an 'event'
 *  - It has at least some siblings
 *  - It's siblings are less than MAX_SIBLINGS
 *  - It is positioned furthest right in the layout
 *
 * @param node {object} data of individual node from Workflow::Graph.as_json
 * @param layout {Layout}
 * @return node {object} with it's element modified with appropriate data
 * attributes if it is extendable
 */
const determineExtendable = (node, layout) => {
  if (node.kind !== "event" || !node.siblings) {
    return node
  }

  const sources = layout.graph.sources()
  // It's a root node
  if (sources.includes(node.id.toString())) {
    const roots = sources.map(source => {
      return layout.graph.node(source)
    })

    const furthestRight = _.orderBy(roots, ["x"], ["desc"])[0]

    furthestRight.element.dataset.extendable =
      roots.length < MAX_SIBLINGS ? true : false
  } else {
    node.siblings.push(node.id)

    const siblings = node.siblings.map(id => layout.graph.node(id))
    const furthestRight = _.orderBy(siblings, ["x"], "desc")[0]

    furthestRight.element.dataset.extendable =
      siblings.length < MAX_SIBLINGS ? true : false
  }

  return node
}

/**
 * Iterates over an array of JSON nodes produced from Workflow::Graph.as_json
 * and determines if they are extendible, if they need a button to the right
 * indicating a sibling can be added.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 * @return data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 */
export const determineExtendableNodes = data => {
  const nodes = data.nodes.map(node => {
    return determineExtendable(node, data.layout)
  })

  return {
    ...data,
    nodes: nodes
  }
}

